module.exports = __webpack_public_path__ + "static/media/documentpayslip.48ec1e30.svg";